import { NgModule } from '@angular/core';

import { FuseSharedModule } from '@fuse/shared.module';

import { QuickPanelComponent } from './quick-panel.component';
import { EstabelecimentoModule } from 'app/main/pages/authentication/estabelecimento/estabelecimento.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from 'app/shared/shared.module';

@NgModule({
    declarations: [
        QuickPanelComponent
    ],
    imports     : [
        SharedModule,
        EstabelecimentoModule,
        BrowserAnimationsModule,
        FuseSharedModule,
    ],
    exports: [
        QuickPanelComponent
    ]
})
export class QuickPanelModule
{
}
